import { formatCompact } from "@/lib/format";

interface MedianViewsColumnCellProps {
  medianViews: number | undefined;
}

export default function MedianViewsColumnCell({
  medianViews,
}: MedianViewsColumnCellProps) {
  return <div className="text-muted-foreground font-mono">{formatCompact(medianViews)}</div>;
}
